import { getRetailerInfo as getRetailerInfoService } from '../services';
import { GET_RETAILER_INFO } from './types';

export const getRetailerInfo = () => (dispatch) => getRetailerInfoService()
  .then((res) => res.json())
  .then((retailerInfo) => {
    dispatch({ type: GET_RETAILER_INFO, payload: retailerInfo });
  });
